import { TModule, TModuleMountObject } from '../types';

/**
 * Get a module object from a window by module mount point definition
 * @param moduleConfig
 */
export const getModuleMountObject = (moduleConfig: TModule): TModuleMountObject | undefined => {
    // Check if window.comgate.checkout.xxx, as defined in mountPoint, is defined and exists as an object in window
    const moduleObject = moduleConfig.mountPoint.reduce((accumulator, currentValue) => accumulator?.[currentValue], window as Record<string, any>);
    if (validateModuleObject(moduleObject)) {
        return moduleObject;
    }
    return undefined;
};

/**
 * Validate module object
 * @param object
 */
export const validateModuleObject = (object: unknown): object is TModuleMountObject =>
    (object &&
        typeof object == 'object' &&
        'create' in object &&
        typeof object.create == 'function' &&
        'version' in object &&
        typeof object.version == 'function') as boolean;
